module.exports = __webpack_public_path__ + "static/media/header-img.eefedb35.jpg";